export default __webpack_public_path__ + "25592ead5bf8f053c643441ccb027122.svg";